<template>
  <rest-list-action
    icon="el-icon-remove-outline"
    :title="$t('RestList_Action_Close')"
    :click="click"
  />
</template>

<script>
import RestApi from '@/core/services/RestApi'
import RestListAction from '@/common/components/rest/RestListAction'

export default {
  name: 'RestListActionClose',
  components: { RestListAction },
  inject: ['restList'],

  props: {
    endpoint: {
      type: Object,
      required: true
    }
  },

  methods: {
    click() {
      this.$msgbox({
        title: this.$t('RestList_CloseTitle'),
        message: this.$t('RestList_ClosePrompt', { label: this.name }),
        showCancelButton: true,
        confirmButtonText: this.$t('RestList_CloseConfirmButton'),
        cancelButtonText: this.$t('RestList_CloseCancelButton'),
        dangerouslyUseHTMLString: true,
        center: true
      }).then(() => {
        this.restList.loading = true
        RestApi(this.endpoint)
          .then(() => {
            this.$message({
              message: this.$t('RestList_CloseSuccessMessage'),
              type: 'success'
            })
            this.restList.refresh()
            this.restList.loading = false
          })
          .catch(error => {
            this.restList.loading = false
            this.$message({
              message: error.message,
              type: 'error'
            })
          })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/campaigns/components/RestListActionClose.vue